export enum ESponsorFormMode {
  VIEW = 'VIEW',
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  CLONE = 'CLONE',
}

export enum ESponsorType {
  BASE = 'BASE',
  FLEET = 'FLEET',
  API = 'API',
  DELTA = 'DELTA',
}

export enum ESponsorStatus {
  ACTIVE = 'ACTIVE',
  // to be added after clarification with backend
  // PENDING = 'PENDING',
  SUSPENDED = 'SUSPENDED',
  TERMINATED = 'TERMINATED',
  ARCHIVED = 'ARCHIVED',
}

export enum EBusinessUnitType {
  B2B = 'B2B',
  B2C = 'B2C',
}

export enum EBusinessModelType {
  B2C = 'B2C',
  B2B2C = 'B2B2C',
  RYD_FLEET_CONNECT = 'RYD_FLEET_CONNECT',
  RYD_FLEET = 'RYD_FLEET',
}

export enum EPartnerCategory {
  OEM = 'OEM',
  CARSHARING = 'CARSHARING',
  TAXI = 'TAXI',
  FLEET_MANAGEMENT = 'FLEET_MANAGEMENT',
  API_INTEGRATION = 'API_INTEGRATION',
}

export enum EPricingModel {
  LIST_PRICE = 'LIST_PRICE',
  PUMP_PRICE = 'PUMP_PRICE',
}

export enum EListPriceCycle {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export enum EContractStatusReason {
  PAYMENT_OVERDUE = 'PAYMENT_OVERDUE',
  CONTRACT_VIOLATION = 'CONTRACT_VIOLATION',
  VOLUNTARY_SUSPENSION = 'VOLUNTARY_SUSPENSION',
  CONTRACT_EXPIRED = 'CONTRACT_EXPIRED',
  CONTRACT_CANCELLED = 'CONTRACT_CANCELLED',
  BUSINESS_CLOSURE = 'BUSINESS_CLOSURE',
  COMPLIANCE_ISSUE = 'COMPLIANCE_ISSUE',
  TECHNICAL_ISSUE = 'TECHNICAL_ISSUE',
}

export enum EFeeMethod {
  DIRECT_CREDIT = 'DIRECT_CREDIT',
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  PAYPAL = 'PAYPAL',
  AMAZON_PAY = 'AMAZON_PAY',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  FUEL_CARD = 'FUEL_CARD',
  MBWAY = 'MBWAY',
  BLUECODE = 'BLUECODE',
  PAYCONIQ = 'PAYCONIQ',
}

export enum EFeeStrategy {
  PERCENTAGE = 'percentage',
  COMBINED = 'combined',
  FLAT_RATE = 'flat_rate',
}
